import React from "react";

const DashboardCard = ({ title, value, icon, iconColor, onClick }) => {
  const isImageIcon = typeof icon === 'string';
  const IconComponent = !isImageIcon ? icon : null;
  
  return (
    <div
      className="dashboard-card"
      onClick={onClick}
      style={onClick ? { cursor: "pointer" } : undefined}
    >
      <div className="dashboard-card-content">
        <div className="dashboard-card-info">
          <p className="dashboard-card-title">{title}</p>
          <p className="dashboard-card-value">{value}</p>
        </div>
        <div className="dashboard-card-icon" style={{ backgroundColor: iconColor }}>
          {isImageIcon ? (
            <img src={icon} alt={title} className="dashboard-icon" />
          ) : (
            IconComponent && <IconComponent className="dashboard-icon" />
          )}
        </div>
      </div>
    </div>
  );
};

export default DashboardCard;

